import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { SetupService } from '../setup/setup.service';
import { PhysicianBaseLayout } from "./PhysicianBaseLayout";

// import { PhysicianService } from '../physician.service';
@Component({
//   selector: 'app-physician-layout',
  templateUrl: './physician-layout.component.html',
  styleUrls: ['./physician-layout.scss']
})
export class PhysicianLayoutWithoutSelectorComponent extends PhysicianBaseLayout {

  constructor(private practiceService: PracticeService, private userService: UserService, private router: Router,
    private setupService: SetupService) {
    super(practiceService, userService, router, setupService);
    this.showPhysicianSelector = false;
  }


}
